import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const RulesPreviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const TermsPreviewSection = styled.div`
  margin-bottom: 24px;
`

export const SectionTitle = styled.h5`
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const TermsPreviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`

export const TermsPreviewItem = styled.div``

export const FieldTitle = styled.h6`
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const NoTermsText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`
